import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomComponentState } from '../reducers/customcomponent.reducer';

export const ccState: any = createFeatureSelector<CustomComponentState>('customComponent');

export const allCCs = createSelector(ccState, (state: any) => {
  return state.allCCs;
});

export const allCCsForApp = createSelector(ccState, (state: any) => {
  return state.allCCForApp;
});

export const currentCC = createSelector(ccState, (state: any) => {
  return state.currentCC;
});
export const ccData = createSelector(ccState, (state: any) => {
  return state.data;
});

export const componentLoader = createSelector(ccState, (state: any) => {
  return state.loader;
});

export const savedCC = createSelector(ccState, (state: any) => {
  return state.ccData;
});
